import { useEffect } from "react";
import { useHotkeysContext } from "react-hotkeys-hook";

export const useDisableHotkeyScopes = (
  scopes: readonly string[],
  enabled: boolean,
  scopeToEnable = "disablingScopes"
) => {
  const { enableScope, disableScope } = useHotkeysContext();

  useEffect(() => {
    if (enabled) {
      enableScope(scopeToEnable); // we need at least one scope of react-hotkeys-hook will enable all scopes by default
      scopes.forEach((scope) => {
        disableScope(scope);
      });
      return () => {
        disableScope(scopeToEnable);
        scopes.forEach((scope) => {
          enableScope(scope);
        });
      };
    }
    // eslint-disable-next-line @eslint-react/exhaustive-deps -- scopeToEnable has a stable default; including it causes unnecessary re-runs
  }, [enabled, enableScope, disableScope, scopes]);
};
